import { render, staticRenderFns } from "./navbar.vue?vue&type=template&id=0523d072&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"
import style0 from "./navbar.vue?vue&type=style&index=0&id=0523d072&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0523d072",
  null
  
)

export default component.exports